import { render } from "./IntentsOld.vue?vue&type=template&id=75015b64&scoped=true&lang=pug"
import script from "./Intents.js?vue&type=script&lang=js&external"
export * from "./Intents.js?vue&type=script&lang=js&external"

import "./IntentsOld.vue?vue&type=style&index=0&id=75015b64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75015b64"]])

export default __exports__